import React from "react"
import { graphql } from "gatsby"
import { Container } from "@theme-ui/components"
import Layout from "../components/layout"
import { getStoriesPath, getStoryCategoryPath } from "../utils/path"
import CategoriesList from "./categoriesList"
import BlogTitle from "../components/blogTitle"
import { HelmetDatoCms } from "gatsby-source-datocms"
import StoriesList from "./storiesList"
import FilterMetaTagDescription from "../utils/filterMetaTags"

const StoryCategory = ({ data: { page, articles, articleCategories } }) => {
  const i18nPaths = page._allSlugLocales.map(path => {
    return {
      locale: path.locale,
      value: getStoryCategoryPath(page, path.locale),
    }
  })

  // console.log(page.seoMetaTags)

  return (
    <Layout
      locale={page.locale}
      i18nPaths={i18nPaths}
      theme="dark"
      hideMenu={true}
    >
      <HelmetDatoCms seo={FilterMetaTagDescription(page.seoMetaTags)}>
        <html lang={page.locale} />
      </HelmetDatoCms>
      <Container sx={{ mt: [8, "16rem"] }}>
        <BlogTitle page={page} />
        <CategoriesList
          categories={articleCategories.nodes}
          getRootPath={getStoriesPath}
          getCategoryPath={getStoryCategoryPath}
        />
        <StoriesList articles={articles.nodes} />
      </Container>
    </Layout>
  )
}

export default StoryCategory

export const query = graphql`
  query StoryCategoryQuery($id: String!, $locale: String!) {
    page: datoCmsStoryCategory(id: { eq: $id }) {
      ...StoryCategoryDetails
      ...StoryCategoryAllSlugLocales
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    articles: allDatoCmsStory(
      sort: { fields: meta___firstPublishedAt, order: DESC }
      filter: {
        slug: { ne: null }
        locale: { eq: $locale }
        category: { id: { eq: $id } }
      }
    ) {
      nodes {
        ...StoryDetails
        ...StoryAllSlugLocales
        ...StoryMeta
      }
    }
    articleCategories: allDatoCmsStoryCategory(
      sort: { fields: position, order: ASC }
      filter: { slug: { ne: null }, locale: { eq: $locale } }
    ) {
      nodes {
        ...StoryCategoryDetails
        ...StoryCategoryAllSlugLocales
      }
    }
    site: datoCmsSite {
      locales
    }
  }

  fragment StoryCategoryAllSlugLocales on DatoCmsStoryCategory {
    _allSlugLocales {
      value
      locale
    }
  }

  fragment StoryCategoryDetails on DatoCmsStoryCategory {
    id
    locale
    title
    slug
    model {
      apiKey
    }
  }
`
